import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CustomBackButtonComponent } from '@shared/components/custom-back-button/custom-back-button.component';

@Component({
  standalone: true,
  imports: [NgIf, CustomBackButtonComponent],
  selector: 'app-page-header',
  templateUrl: 'page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input() backButtonCustomPath: string | undefined = undefined;
}
